const ENPHASE_INSTALLER = 'enphase_installer'
const CUSTOMER_SUPPORT = 'customer_support'
const ENPHASE_INSTALLER_LOGIN_DISCLAIMER =
  'Use your Enlighten Manager credentials to submit applications on behalf of homeowners'
const CUSTOMER_SUPPORT_LOGIN_DISCLAIMER =
  'Use your Enligten Manager credentials to validate the submitted applications'

export {
  ENPHASE_INSTALLER,
  CUSTOMER_SUPPORT,
  ENPHASE_INSTALLER_LOGIN_DISCLAIMER,
  CUSTOMER_SUPPORT_LOGIN_DISCLAIMER,
}
